<template>
  <tr class="collapsible-list-row-header">
    <slot />
  </tr>
</template>

<script>
export default {
  name: 'CollapsibleRow'
}
</script>